export const getCSVFile = (items) => {
	const replacer = (key, value) => (value === null ? '' : value)
	const header = Object.keys(items[0])
	const csv = [header.join(','), ...items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))].join(
		'\r\n',
	)

	return new Blob([csv], { type: 'text/csv' })
}

/**
 * @param {Blob} blob 
 * @param {string} filename 
 * @returns File
 */
export const blobToFile = (blob, filename) => {
	return new File([blob], filename, { type: blob.type })
}

/**
 * @param {string} fileUrl 
 * @returns Promise<Blob>
 */
export const urlToBlob = async (fileUrl) => {
	const response = await fetch(fileUrl)
	return response.blob()
}

/**
 * @param {string} url
 * @param {string} filename
 * @returns Promise<File>
 */
export const urlToFile = async (url, filename) => {
	const blob = await urlToBlob(url)
	return blobToFile(blob, filename)
}

/**
 * @param {File} file 
 * @returns string
 */
export const fileToUrl = (file) => {
	return URL.createObjectURL(file)
}

/**
 * @param {string} fileName 
 * @returns string
 */
export function getFileNameNoExtension(fileName) {
	const i = fileName.lastIndexOf('.')
	return i === -1 ? fileName : fileName.slice(0, i)
}
